export default __webpack_public_path__ + "static/media/accomm_img_7.bf528ed6.JPG";